











































































import { Decimal } from 'decimal.js';
import {
  Component,
  Vue,
} from 'vue-property-decorator';

import { Money } from '@/lib/money';
import { ProductVariant } from '@/models';

import PriceBlock from '@/components/PriceBlock.vue';

import ProductFeature from './ProductFeature';

@Component({
  components: {
    PriceBlock,
  },
})
export default class DesktopPriceFeature extends ProductFeature {
  public readonly priceClassObj = [
    'is-size-medium',
    'has-text-weight-bold',
    'has-text-price',
  ];

  get price() {
    const unselectedOptionIndices = this.unselectedOptionIndices;
    if (unselectedOptionIndices.length <= 0) {
      return (this.previewVariant) ? this.previewVariant.price : this.variant.price;
    } else {
      const otherVariants = this.variant.getOtherVariantsDifferFor(unselectedOptionIndices);

      let minPrice: Money | null = null;
      let maxPrice: Money | null = null;
      otherVariants.forEach((variant) => {
        const price = variant.price;
        if (price) {
          if (!minPrice) {
            minPrice = maxPrice = price;
          } else {
            if (price.amount.lessThan(minPrice.amount)) {
              minPrice = price;
            } else if (price.amount.greaterThan(maxPrice!.amount)) {
              maxPrice = price;
            }
          }
        }
      });

      if (!!minPrice) {
        return [minPrice!, maxPrice!];
      } else {
        return undefined;
      }
    }
  }

  get compareAtPrice() {
    return this.hasUnselectedOptions ? undefined :
      (this.previewVariant) ? this.previewVariant.compareAtPrice : this.variant.compareAtPrice;
  }

  get priceDiff(): Money | undefined {
    return (this.compareAtPrice && this.variant.price) ? {
      amount: this.compareAtPrice.amount.sub(this.variant.price.amount),
      currency: this.variant.product.priceCurrency,
    } : undefined;
  }
}

